export const rsvpI18n = {
    en: {
        rsvpPage: {
            forms: {
                inv: 'https://docs.google.com/forms/d/e/1FAIpQLSesPK1skS9bTu_GH11hU4PeH_7F8wZY0nubSejC5MeTM6U6lg/viewform?usp=header',
                menu: 'https://docs.google.com/forms/d/e/1FAIpQLSeJhBEDFNRnzmIK1nz-jFGQHiWia81Lg7pPqA28iuzRLNKlBQ/viewform?usp=header',
            },
            invitation: "Invitation",
            dinnerTitle: "Dinner",
            subtitle: "Répondez s'il vous plaît",
            letter: {
                greeting: "Dear Guest!",
                message: "To make everything perfect, we would like to gather some important information."
            },
            greeting: "Dear Guest!",
            instruction: "To make everything perfect, we would like to gather some important information.",
            arrival: {
                title: "Arrival",
                question: "Are you planning to come alone or with a partner?",
                how: "How?"
            },
            dinner: {
                title: "Dinner",
                bride: "Bride's favorite?",
                groom: "Groom's favorite?"
            },
            nextDay: {
                title: "Next Day",
                question: "Barbeque party?"
            },
            cta: {
                title: "Do you have answers to all the questions?",
                message: "If yes, please help us by sharing this with us using the forms below!",
                disclaimer1: "* Preferences for dinner can be submitted after the trial meal (2025. 03. 16).",
                disclaimer2: "After the mentioned date, the detailed menu marked as the bride's and groom's favorite will be available."
            },
            by: "by @szalontaijordan"
        }
    },
    hu: {
        rsvpPage: {
            forms: {
                inv: 'https://docs.google.com/forms/d/e/1FAIpQLSdbfEuhIuAbGZxGUvpH_R57fYnydiWOtSS4XP6C6DJ-XayX_g/viewform?usp=sharing',
                menu: 'https://docs.google.com/forms/d/e/1FAIpQLSfLiOspV8ryOcaOfyYNZcqu68TzUSM2rdhe-cMcHzkY4WuOyQ/viewform?usp=header',
            },
            invitation: "Meghívó",
            dinnerTitle: "Vacsora",
            subtitle: "Répondez s'il vous plaît",
            letter: {
                greeting: "Kedves Vendég!",
                message: "Ahhoz, hogy minden részlet tökéletes legyen, szeretnénk néhány fontos információt összegyűjteni."
            },
            greeting: "Kedves Vendég!",
            instruction: "Ahhoz, hogy minden részlet tökéletes legyen, szeretnénk néhány fontos információt összegyűjteni.",
            arrival: {
                title: "Érkezés",
                question: "Egyedül vagy párban tervezel érkezni?",
                how: "Milyen módon?"
            },
            dinner: {
                title: "Vacsora",
                bride: "Menyasszony kedvence?",
                groom: "Vőlegény kedvence?"
            },
            nextDay: {
                title: "Másnap",
                question: "Barbeque party?"
            },
            cta: {
                title: "Megvan a válasz minden kérdésre?",
                message: "Ha igen, kérlek segíts nekünk azzal, hogy az alábbi űrlapok segítségével megosztod ezt velünk!",
                disclaimer1: "* A vacsorára vonatkozó preferenciákat a próbaétkezést követően (2025. 03. 16.) lehet majd leadni.",
                disclaimer2: "Az említett dátum után mind a menyasszony-, mind a vőlegény kedvenceként megjelölt menüsor részletesen elérhető lesz."
            },
            by: "by @szalontaijordan"
        }
    }
};
